import { render, staticRenderFns } from "./Reset_Password2.vue?vue&type=template&id=0c61602c&scoped=true&"
import script from "./Reset_Password2.vue?vue&type=script&lang=js&"
export * from "./Reset_Password2.vue?vue&type=script&lang=js&"
import style0 from "./Reset_Password2.vue?vue&type=style&index=0&id=0c61602c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c61602c",
  null
  
)

export default component.exports